module.exports = __webpack_public_path__ + "static/media/buy-more-enterprice-discussion.1c470b03.png";